import { ActionIcon, Badge, Box, Button, Divider, Drawer, Grid, Group, Paper, ScrollArea, Select, Stack, Table, Tabs, Text, Textarea, ThemeIcon, Title, Code, Tooltip, Accordion, Anchor, Alert, NumberInput, Checkbox, Skeleton } from "@mantine/core";
import { useDisclosure } from '@mantine/hooks';

import { IconChecklist, IconClock, IconEye, IconFileDescription, IconShieldCheck, IconProgress, IconEdit } from "@tabler/icons-react";
import { useState, useEffect } from "react";
import { message, Space } from "antd";
import { useAuthContext } from "../../Hooks/UseAuthContext";

const MerchantOnboard = () => {
    const { user } = useAuthContext();
    const [dashboardData, setDashboardData] = useState(null);
    const [dashboardLoading, setDashboardLoading] = useState(true);
    const [opened, { open, close }] = useDisclosure(false);
    const [selectedMerchant, setSelectedMerchant] = useState(null);
    const [users, setusers] = useState([]);
    const [usersloading, setusersloading] = useState(true);

    const [aoRemarks, setAoRemarks] = useState("");
    const [onboardRemarks, setOnboardRemarks] = useState("");
    const [legalRemarks, setLegalRemarks] = useState("");
    const [reviewRemarks, setReviewRemarks] = useState("");

    const [status, setStatus] = useState("");
    const [verificationStep, setVerificationStep] = useState("");
    const [verificationUpdateloading, setVerificationUpdateloading] = useState(false);

    const [rectificationSteps, setRectificationSteps] = useState([]);


    // =========================================
    // STATUS COLOR
    // =========================================

    const getStatusColor = (status) => {

        switch (status) {

            case "Approved":
                return "green";

            case "Rejected":
                return "red";

            case "Rectification Required":
                return "orange";

            case "Under Review":
                return "blue";

            default:
                return "yellow";
        }
    };

    const getAllusers_onboarding_details = async () => {

        try {
            //setDashboardLoading(true);
            const response = await fetch("https://api.boompay.in/admin/get-user-onboarding-details",
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${user}`,
                    }
                }
            );

            const data = await response.json();
            if (response.status === 200) {
                // console.log(data);
                setusers(data.OnboardMerchants);
            } else {
                message.error(data.message);
            }

        } catch (error) {
            console.log(error);
            message.error(error?.message);

        } finally {
            setusersloading(false);
        }
    };

    const handleUpdateRemarks = async () => {

        try {
            setVerificationUpdateloading(true);
            const response = await fetch("https://api.boompay.in/admin/update-user-onboarding-verification-status", {
                method: "PUT",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                },
                body: JSON.stringify({
                    submissionId: selectedMerchant._id,
                    Aoremarks: aoRemarks,
                    Onboardremarks: onboardRemarks,
                    Legalremarks: legalRemarks,
                    finalremarks: reviewRemarks,
                    status: status,
                    verificationStep: verificationStep,
                    rectificationSteps
                }),
            });

            const data = await response.json();

            if (response.status === 200) {
                message.success(data.message);
                // Refresh the user list or update the selected merchant's data
                getAllusers_onboarding_details();
                setVerificationUpdateloading(false);
                setAoRemarks("");
                setOnboardRemarks("");
                setLegalRemarks("");
                setReviewRemarks("");
                setStatus("");
                setVerificationStep("");
                close(); // Close the drawer after successful update
            } else {
                message.error(data.message);
                setVerificationUpdateloading(false);
            }
        } catch (error) {
            console.log(error);
            setVerificationUpdateloading(false);
            message.error("Failed to update remarks");
        }
    }

    // =========================================
    // RECTIFICATION OPTIONS
    // =========================================

    const rectificationOptions = [

        {
            value: 0,
            label: "Company Profile",
        },

        {
            value: 1,
            label: "Compliance & MAF",
        },

        {
            value: 2,
            label: "Bank Details",
        },

        {
            value: 3,
            label: "Merchant Due Diligence",
        },

        {
            value: 4,
            label: "Board Resolution",
        },

        {
            value: 5,
            label: "Merchant Criminal Undertaking",
        },

        {
            value: 6,
            label: "Commercial Offer Letter",
        },

        {
            value: 7,
            label: "Upload Documents",
        },

        {
            value: 8,
            label: "Terms & Conditions",
        }

    ];

    const handleRectificationChange = (step, checked) => {

        if (checked) {

            setRectificationSteps(prev => [

                ...prev,

                {
                    step: step.value,
                    step_name: step.label,
                    remark: "",
                    status: "Pending"
                }

            ]);

        } else {

            setRectificationSteps(prev =>
                prev.filter(item => item.step !== step.value)
            );

        }

    };

    const handleRectificationRemark = (stepNumber, value) => {

        setRectificationSteps(prev =>

            prev.map(item =>

                item.step === stepNumber

                    ? {
                        ...item,
                        remark: value
                    }

                    : item

            )

        );

    };


    useEffect(() => {

        // ==========================================
        // FRONTEND API FUNCTION
        // ==========================================

        const getDashboardCounts = async () => {

            try {
                //setDashboardLoading(true);
                const response = await fetch("https://api.boompay.in/admin/dashboard-counts",
                    {
                        method: "GET",
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${user}`,
                        }
                    }
                );

                const data = await response.json();
                if (response.status === 200) {
                    setDashboardData(data.dashboard);
                } else {
                    message.error(data.message);
                }

            } catch (error) {
                console.log(error);
                message.error("Failed to fetch dashboard data");
            } finally {
                setDashboardLoading(false);
            }
        };

        const getAllusers_onboarding_details = async () => {

            try {
                //setDashboardLoading(true);
                const response = await fetch("https://api.boompay.in/admin/get-user-onboarding-details",
                    {
                        method: "GET",
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${user}`,
                        }
                    }
                );

                const data = await response.json();
                if (response.status === 200) {
                    //console.log(data);
                    setusers(data.OnboardMerchants);
                } else {
                    message.error(data.message);
                }
            } catch (error) {
                console.log(error);
                message.error(error?.message);

            } finally {
                setusersloading(false);
            }
        };

        if (user) {
            getDashboardCounts();
            getAllusers_onboarding_details();
        }
        // getDashboardCounts();
        // getAllusers_onboarding_details();
    }, [user])

    useEffect(() => {

        if (selectedMerchant) {

            setStatus(selectedMerchant.onboarding_status);
            setVerificationStep(selectedMerchant.verification_step);

            setAoRemarks(
                selectedMerchant?.onboard_remark?.[0]?.ao_remarks || ""
            );

            setOnboardRemarks(
                selectedMerchant?.onboard_remark?.[0]?.onboardteam_remarks || ""
            );

            setLegalRemarks(
                selectedMerchant?.onboard_remark?.[0]?.leagalteam_remarks || ""
            );

            setReviewRemarks(
                selectedMerchant?.onboard_remark?.[0]?.reviewteam_remarks || ""
            );

            setRectificationSteps(selectedMerchant?.onboard_remark?.[0]?.rectification_steps || []);

        }

    }, [selectedMerchant]);

    return (

        <Box p="md">

            {/* ========================================= */}
            {/* PAGE HEADER */}
            {/* ========================================= */}

            <Group
                justify="space-between"
                mb="lg"
            >

                <div>

                    <Title order={2}>
                        Merchant Onboarding
                    </Title>

                    <Text c="dimmed">
                        Manage and verify merchant onboarding
                    </Text>

                </div>

            </Group>

            {/* ========================================= */}
            {/* TOP CARDS */}
            {/* ========================================= */}
            <Grid mb="lg">

                {[
                    {
                        title: "Total Onboards",
                        value: dashboardData?.onboarding?.total_onboarding || "0",
                        color: "blue",
                        icon: <IconChecklist size={22} />,
                    },
                    {
                        title: "Under Review",
                        value: dashboardData?.onboarding?.under_review_onboarding || "0",
                        color: "yellow",
                        icon: <IconProgress size={22} />,
                    },

                    {
                        title: "Pending",
                        value: dashboardData?.onboarding?.pending_onboarding || "0",
                        color: "yellow",
                        icon: <IconClock size={22} />,
                    },

                    {
                        title: "Approved",
                        value: dashboardData?.onboarding?.approved_onboarding || "0",
                        color: "green",
                        icon: <IconShieldCheck size={22} />,
                    },
                    {
                        title: "Retification",
                        value: dashboardData?.onboarding?.rectification_onboarding || "0",
                        color: "orange",
                        icon: <IconEdit size={22} />,
                    },
                    {
                        title: "Rejected",
                        value: dashboardData?.onboarding?.rejected_onboarding || "0",
                        color: "red",
                        icon: <IconFileDescription size={22} />,
                    },

                ].map((card, index) => (

                    <Grid.Col
                        key={index}
                        span={{
                            base: 12,
                            sm: 6,
                            md: 3
                        }}
                    >
                        <Skeleton visible={dashboardLoading}>
                            <Paper
                                withBorder
                                radius="xl"
                                p="xl"
                                h="100%"
                            >

                                <Group
                                    justify="space-between"
                                >

                                    <Stack gap={2}>

                                        <Text
                                            size="sm"
                                            c="dimmed"
                                        >
                                            {card.title}
                                        </Text>

                                        <Title order={2}>
                                            {card.value}
                                        </Title>

                                    </Stack>

                                    <ThemeIcon
                                        size={50}
                                        radius="xl"
                                        color={card.color}
                                        variant="light"
                                    >
                                        {card.icon}
                                    </ThemeIcon>

                                </Group>

                            </Paper>
                        </Skeleton>

                    </Grid.Col>

                ))}

            </Grid>

            {/* ========================================= */}
            {/* MAIN TABLE */}
            {/* ========================================= */}

            <Paper
                withBorder
                radius="xl"
                p="md"
            >

                <Group
                    justify="space-between"
                    mb="md"
                >

                    <Title order={4}>
                        Merchant List
                    </Title>

                    <Group>

                        <Select
                            placeholder="Filter Status"
                            data={[
                                "Pending",
                                "Approved",
                                "Rejected",
                                "Rectification Required",
                            ]}
                        />

                    </Group>

                </Group>

                <Skeleton visible={usersloading}>
                    <Table
                        striped
                        highlightOnHover
                        withTableBorder
                        withColumnBorders
                        verticalSpacing="sm"
                    >

                        <Table.Thead>

                            <Table.Tr>

                                <Table.Th>S.No</Table.Th>

                                <Table.Th>Company</Table.Th>

                                <Table.Th>PAN</Table.Th>

                                <Table.Th>Contact</Table.Th>

                                <Table.Th>Services</Table.Th>

                                <Table.Th>Current Step</Table.Th>

                                <Table.Th>Status</Table.Th>

                                <Table.Th>Submitted On</Table.Th>

                                <Table.Th
                                    style={{
                                        width: 140,
                                        textAlign: "center"
                                    }}
                                >
                                    Action
                                </Table.Th>

                            </Table.Tr>

                        </Table.Thead>

                        <Table.Tbody>

                            {users?.length > 0 ? (

                                users.map((merchant, index) => (

                                    <Table.Tr key={merchant._id}>

                                        {/* S.No */}

                                        <Table.Td>
                                            {index + 1}
                                        </Table.Td>

                                        {/* Company */}

                                        <Table.Td>

                                            <Stack gap={2}>

                                                <Text fw={600}>
                                                    {merchant.Registered_Name_of_Company}
                                                </Text>

                                                <Text
                                                    size="xs"
                                                    c="dimmed"
                                                >
                                                    GST :
                                                    {" "}
                                                    {merchant.Registered_GST_Number}
                                                </Text>

                                            </Stack>

                                        </Table.Td>

                                        {/* PAN */}

                                        <Table.Td>

                                            <Code>
                                                {merchant.Registered_PAN_Number}
                                            </Code>

                                        </Table.Td>

                                        {/* Contact */}

                                        <Table.Td>

                                            <Stack gap={2}>

                                                <Text size="sm">

                                                    {
                                                        merchant
                                                            ?.Signup_schema_id
                                                            ?.Authorized_Person_Name
                                                    }

                                                </Text>

                                                <Text
                                                    size="xs"
                                                    c="dimmed"
                                                >

                                                    {
                                                        merchant
                                                            ?.Signup_schema_id
                                                            ?.Authorized_Person_Mobile_Number
                                                    }

                                                </Text>

                                            </Stack>

                                        </Table.Td>

                                        {/* Services */}

                                        <Table.Td>

                                            <Group gap={4}>

                                                {
                                                    merchant
                                                        ?.Company_profile_schema_id
                                                        ?.Services_opted
                                                        ?.slice(0, 2)
                                                        ?.map((service, i) => (

                                                            <Badge
                                                                size="xs"
                                                                key={i}
                                                                variant="light"
                                                                color="blue"
                                                            >
                                                                {service}
                                                            </Badge>

                                                        ))
                                                }

                                                {
                                                    merchant
                                                        ?.Company_profile_schema_id
                                                        ?.Services_opted
                                                        ?.length > 2 && (

                                                        <Badge
                                                            color="gray"
                                                            size="xs"
                                                        >

                                                            +

                                                            {

                                                                merchant
                                                                    ?.Company_profile_schema_id
                                                                    ?.Services_opted
                                                                    ?.length - 2

                                                            }

                                                        </Badge>

                                                    )
                                                }

                                            </Group>

                                        </Table.Td>

                                        {/* Verification Step */}

                                        <Table.Td>

                                            <Badge
                                                color="violet"
                                                variant="filled"
                                                size="xs"
                                            >

                                                Step
                                                {" "}
                                                {merchant.verification_step}

                                            </Badge>

                                        </Table.Td>

                                        {/* Status */}

                                        <Table.Td>

                                            <Badge
                                                size="xs"
                                                color={
                                                    merchant.onboarding_status === "Approved"
                                                        ? "green"
                                                        : merchant.onboarding_status === "Rejected"
                                                            ? "red"
                                                            : merchant.onboarding_status === "Rectification Required"
                                                                ? "orange"
                                                                : merchant.onboarding_status === "Under Review"
                                                                    ? "blue"
                                                                    : "yellow"
                                                }
                                            >

                                                {merchant.onboarding_status}

                                            </Badge>

                                        </Table.Td>

                                        {/* Submitted */}

                                        <Table.Td>

                                            {new Date(
                                                merchant.createdAt
                                            ).toLocaleDateString("en-IN")}

                                        </Table.Td>

                                        {/* Action */}

                                        <Table.Td>

                                            <Group
                                                gap="xs"
                                                justify="center"
                                            >

                                                <Tooltip label="View Details">

                                                    <ActionIcon
                                                        variant="light"
                                                        color="blue"
                                                        onClick={() => {

                                                            setSelectedMerchant(
                                                                merchant
                                                            );

                                                            open(); // open the drawer

                                                        }}
                                                    >

                                                        <IconEye size={18} />

                                                    </ActionIcon>

                                                </Tooltip>
                                            </Group>

                                        </Table.Td>

                                    </Table.Tr>

                                ))

                            ) : (

                                <Table.Tr>

                                    <Table.Td
                                        colSpan={9}
                                        align="center"
                                    >

                                        <Text c="dimmed">

                                            No onboarding requests found.

                                        </Text>

                                    </Table.Td>

                                </Table.Tr>

                            )}

                        </Table.Tbody>

                    </Table>
                </Skeleton>

            </Paper>

            {/* ========================================= */}
            {/* REVIEW DRAWER */}
            {/* ========================================= */}

            <Drawer
                opened={opened}
                onClose={close}
                title="Merchant Onboarding Details"
                position="right"
                size="100%"
                scrollAreaComponent={ScrollArea.Autosize}
            >

                {selectedMerchant && (

                    <Stack>

                        {/* =============================== */}
                        {/* HEADER */}
                        {/* =============================== */}

                        <Paper
                            withBorder
                            p="md"
                            radius="md"
                        >

                            <Group justify="space-between">

                                <div>

                                    <Title order={3}>
                                        {selectedMerchant.Registered_Name_of_Company}
                                    </Title>

                                    <Text c="dimmed">

                                        Submission ID :
                                        {" "}
                                        {selectedMerchant._id}

                                    </Text>

                                </div>

                                <Badge
                                    size="lg"
                                    color={
                                        getStatusColor(
                                            selectedMerchant.onboarding_status
                                        )
                                    }
                                >
                                    {selectedMerchant.onboarding_status}
                                </Badge>

                            </Group>

                        </Paper>

                        {/* =============================== */}
                        {/* BASIC DETAILS */}
                        {/* =============================== */}

                        <Paper withBorder p="md">

                            <Title order={5} mb="md">
                                Company Information
                            </Title>

                            <Grid>

                                <Grid.Col span={3}>
                                    <Text fw={600}>
                                        Company Name
                                    </Text>

                                    <Text>
                                        {selectedMerchant.Registered_Name_of_Company}
                                    </Text>
                                </Grid.Col>
                                <Grid.Col span={3}>
                                    <Text fw={600}>
                                        Company Incorporation Number
                                    </Text>

                                    <Text>
                                        {selectedMerchant?.Company_profile_schema_id?.Company_CIN_number}
                                    </Text>
                                </Grid.Col>

                                <Grid.Col span={3}>
                                    <Text fw={600}>
                                        PAN Number
                                    </Text>

                                    <Text>
                                        {selectedMerchant.Registered_PAN_Number}
                                    </Text>
                                </Grid.Col>

                                <Grid.Col span={3}>
                                    <Text fw={600}>
                                        GST Number
                                    </Text>

                                    <Text>
                                        {selectedMerchant.Registered_GST_Number}
                                    </Text>
                                </Grid.Col>

                                <Grid.Col span={3}>
                                    <Text fw={600}>
                                        Authorized Signatory
                                    </Text>

                                    <Text>
                                        {selectedMerchant.authorized_signatory_name}
                                    </Text>
                                </Grid.Col>

                                <Grid.Col span={3}>
                                    <Text fw={600}>
                                        Verification Step
                                    </Text>

                                    <Badge>

                                        Step
                                        {" "}
                                        {selectedMerchant.verification_step}

                                    </Badge>

                                </Grid.Col>

                                <Grid.Col span={3}>
                                    <Text fw={600}>
                                        Submitted
                                    </Text>

                                    <Text>

                                        {new Date(
                                            selectedMerchant.createdAt
                                        ).toLocaleDateString()}

                                    </Text>

                                </Grid.Col>

                            </Grid>

                        </Paper>

                        <Tabs variant="pills" color="black" radius={'xl'}>

                            <Tabs.List>
                                <Tabs.Tab value="company">Company</Tabs.Tab>
                                <Tabs.Tab value="bank">Bank</Tabs.Tab>
                                <Tabs.Tab value="compliance">Compliance</Tabs.Tab>
                                <Tabs.Tab value="due">Due Diligence</Tabs.Tab>
                                <Tabs.Tab value="board">Board Resolution</Tabs.Tab>
                                <Tabs.Tab value="undertaking">Undertaking</Tabs.Tab>
                                <Tabs.Tab value="documents">Documents</Tabs.Tab>
                                <Tabs.Tab value="terms">Terms</Tabs.Tab>
                                <Tabs.Tab value="remarks">Remarks</Tabs.Tab>
                            </Tabs.List>

                            <Tabs.Panel value="company" pt="md">

                                <Stack>

                                    {/* ======================================== */}
                                    {/* COMPANY INFORMATION */}
                                    {/* ======================================== */}

                                    <Paper withBorder radius="md" p="lg">

                                        <Title order={4} mb="lg">
                                            Company Information
                                        </Title>

                                        <Grid>

                                            <Grid.Col span={3}>
                                                <Text fw={600}>Company Name</Text>
                                                <Text>
                                                    {selectedMerchant?.Company_profile_schema_id?.Company_name}
                                                </Text>
                                            </Grid.Col>

                                            <Grid.Col span={3}>
                                                <Text fw={600}>PAN Number</Text>
                                                <Text>
                                                    {selectedMerchant?.Company_profile_schema_id?.Company_PAN_number}
                                                </Text>
                                            </Grid.Col>

                                            <Grid.Col span={3}>
                                                <Text fw={600}>GST Number</Text>
                                                <Text>
                                                    {selectedMerchant?.Company_profile_schema_id?.Company_GST_number}
                                                </Text>
                                            </Grid.Col>

                                            <Grid.Col span={3}>
                                                <Text fw={600}>CIN Number</Text>
                                                <Text>
                                                    {selectedMerchant?.Company_profile_schema_id?.Company_CIN_number || "-"}
                                                </Text>
                                            </Grid.Col>

                                            <Grid.Col span={3}>
                                                <Text fw={600}>MSME Number</Text>
                                                <Text>
                                                    {selectedMerchant?.Company_profile_schema_id?.Company_MSME_number || "-"}
                                                </Text>
                                            </Grid.Col>

                                            <Grid.Col span={4}>
                                                <Text fw={600}>Submission Date</Text>
                                                <Text>
                                                    {new Date(selectedMerchant.createdAt).toLocaleDateString()}
                                                </Text>
                                            </Grid.Col>

                                        </Grid>

                                    </Paper>

                                    {/* ======================================== */}
                                    {/* CONTACT DETAILS */}
                                    {/* ======================================== */}

                                    <Paper withBorder radius="md" p="lg">

                                        <Title order={5} mb="lg">
                                            Contact Details
                                        </Title>

                                        <Grid>

                                            <Grid.Col span={6}>
                                                <Text fw={600}>Email Address</Text>
                                                <Text>
                                                    {selectedMerchant?.Company_profile_schema_id?.Company_email}
                                                </Text>
                                            </Grid.Col>

                                            <Grid.Col span={6}>
                                                <Text fw={600}>Mobile Number</Text>
                                                <Text>
                                                    {selectedMerchant?.Company_profile_schema_id?.Company_Mobile_number}
                                                </Text>
                                            </Grid.Col>

                                            <Grid.Col span={12}>
                                                <Text fw={600}>Company Address</Text>
                                                <Text>
                                                    {selectedMerchant?.Company_profile_schema_id?.Company_address}
                                                </Text>
                                            </Grid.Col>

                                        </Grid>

                                    </Paper>

                                    {/* ======================================== */}
                                    {/* SERVICES */}
                                    {/* ======================================== */}

                                    <Paper withBorder radius="md" p="lg">

                                        <Title order={5} mb="lg">
                                            Services Opted
                                        </Title>

                                        <Group>

                                            {selectedMerchant?.Company_profile_schema_id?.Services_opted?.map((service, index) => (

                                                <Badge
                                                    key={index}
                                                    size="lg"
                                                    variant="light"
                                                >
                                                    {service.replaceAll("_", " ")}
                                                </Badge>

                                            ))}

                                        </Group>

                                    </Paper>

                                    {/* ======================================== */}
                                    {/* DIRECTORS */}
                                    {/* ======================================== */}

                                    <Paper withBorder radius="md" p="lg">

                                        <Group justify="space-between" mb="lg">

                                            <Title order={5}>
                                                Directors Information
                                            </Title>

                                            <Badge color="blue">
                                                Total Directors : {selectedMerchant?.Company_profile_schema_id?.Directors?.length}
                                            </Badge>

                                        </Group>

                                        <Table
                                            striped
                                            withTableBorder
                                            withColumnBorders
                                        >

                                            <Table.Thead>

                                                <Table.Tr>

                                                    <Table.Th>S.No</Table.Th>

                                                    <Table.Th>Name</Table.Th>

                                                    <Table.Th>DIN</Table.Th>

                                                    <Table.Th>Mobile</Table.Th>

                                                    <Table.Th>Email</Table.Th>

                                                    <Table.Th>Share %</Table.Th>

                                                    <Table.Th>Appointment Date</Table.Th>

                                                    <Table.Th>Role</Table.Th>

                                                </Table.Tr>

                                            </Table.Thead>

                                            <Table.Tbody>

                                                {selectedMerchant?.Company_profile_schema_id?.Directors?.map((director, index) => (

                                                    <Table.Tr key={index}>

                                                        <Table.Td>
                                                            {index + 1}
                                                        </Table.Td>

                                                        <Table.Td>
                                                            {director.Director_name}
                                                        </Table.Td>

                                                        <Table.Td>
                                                            {director.Director_DIN_number}
                                                        </Table.Td>

                                                        <Table.Td>
                                                            {director.Director_mobile_number}
                                                        </Table.Td>

                                                        <Table.Td>
                                                            {director.Director_email}
                                                        </Table.Td>

                                                        <Table.Td>
                                                            {director.Share_perecentage}%
                                                        </Table.Td>

                                                        <Table.Td>
                                                            {new Date(
                                                                director.Date_of_appointment
                                                            ).toLocaleDateString()}
                                                        </Table.Td>

                                                        <Table.Td>

                                                            <Badge
                                                                color={
                                                                    director.Is_Authroized_signatory
                                                                        ? "green"
                                                                        : "gray"
                                                                }
                                                            >
                                                                {director.Is_Authroized_signatory
                                                                    ? "Authorized Signatory"
                                                                    : "Director"}
                                                            </Badge>

                                                        </Table.Td>

                                                    </Table.Tr>

                                                ))}

                                            </Table.Tbody>

                                        </Table>

                                    </Paper>

                                    {/* ======================================== */}
                                    {/* AUTHORIZED SIGNATORY */}
                                    {/* ======================================== */}

                                    <Paper
                                        withBorder
                                        p="lg"
                                        radius="md"
                                    >

                                        <Title order={5} mb="md">
                                            Authorized Signatory
                                        </Title>

                                        {selectedMerchant?.Company_profile_schema_id?.Directors
                                            ?.filter(d => d.Is_Authroized_signatory)
                                            ?.map((director, index) => (

                                                <Paper
                                                    key={index}
                                                    withBorder
                                                    p="md"
                                                    radius="md"
                                                    mb="sm"
                                                >

                                                    <Group justify="space-between">

                                                        <div>

                                                            <Text fw={700}>
                                                                {director.Director_name}
                                                            </Text>

                                                            <Text size="sm" c="dimmed">
                                                                {director.Director_email}
                                                            </Text>

                                                            <Text size="sm" c="dimmed">
                                                                {director.Director_mobile_number}
                                                            </Text>

                                                        </div>

                                                        <Badge
                                                            size="lg"
                                                            color="green"
                                                        >
                                                            Authorized Signatory
                                                        </Badge>

                                                    </Group>

                                                </Paper>

                                            ))}

                                    </Paper>

                                </Stack>

                            </Tabs.Panel>

                            <Tabs.Panel value="bank" pt="md">

                                <Paper
                                    withBorder
                                    radius="md"
                                    p="lg"
                                >

                                    <Group justify="space-between" mb="lg">

                                        <Title order={4}>
                                            Bank Details
                                        </Title>

                                        <Badge
                                            size="lg"
                                            color="blue"
                                        >
                                            Total Banks :
                                            {" "}
                                            {selectedMerchant?.Bank_details_schema_id?.Banks?.length || 0}
                                        </Badge>

                                    </Group>

                                    <Table
                                        striped
                                        highlightOnHover
                                        withTableBorder
                                        withColumnBorders
                                    >

                                        <Table.Thead>

                                            <Table.Tr>

                                                <Table.Th>S.No</Table.Th>

                                                <Table.Th>Bank Name</Table.Th>

                                                <Table.Th>Account Number</Table.Th>

                                                <Table.Th>IFSC Code</Table.Th>

                                                <Table.Th>Branch</Table.Th>

                                                <Table.Th>Verification</Table.Th>

                                            </Table.Tr>

                                        </Table.Thead>

                                        <Table.Tbody>

                                            {selectedMerchant?.Bank_details_schema_id?.Banks?.length > 0 ? (

                                                selectedMerchant.Bank_details_schema_id.Banks.map(
                                                    (bank, index) => (

                                                        <Table.Tr key={bank._id || index}>

                                                            <Table.Td>
                                                                {index + 1}
                                                            </Table.Td>

                                                            <Table.Td>

                                                                <Group gap={5}>

                                                                    <Text fw={600}>
                                                                        {bank.bank_name}
                                                                    </Text>

                                                                    {index === 0 && (

                                                                        <Badge
                                                                            size="xs"
                                                                            color="green"
                                                                        >
                                                                            Primary
                                                                        </Badge>

                                                                    )}

                                                                </Group>

                                                            </Table.Td>

                                                            <Table.Td
                                                                ff="monospace"
                                                            >
                                                                {bank.account_number}
                                                            </Table.Td>

                                                            <Table.Td>
                                                                {bank.ifsc_code}
                                                            </Table.Td>

                                                            <Table.Td>
                                                                {bank.bank_branch}
                                                            </Table.Td>

                                                            <Table.Td>

                                                                <Badge color="green">
                                                                    Submitted
                                                                </Badge>

                                                            </Table.Td>

                                                        </Table.Tr>

                                                    )
                                                )

                                            ) : (

                                                <Table.Tr>

                                                    <Table.Td
                                                        colSpan={6}
                                                        ta="center"
                                                    >
                                                        No Bank Details Available
                                                    </Table.Td>

                                                </Table.Tr>

                                            )}

                                        </Table.Tbody>

                                    </Table>

                                </Paper>

                            </Tabs.Panel>

                            <Tabs.Panel value="compliance" pt="md">

                                <Stack>

                                    {/* ===================================== */}
                                    {/* COMPLIANCE LINKS */}
                                    {/* ===================================== */}

                                    <Paper
                                        withBorder
                                        radius="md"
                                        p="lg"
                                    >

                                        <Title order={4} mb="lg">
                                            Compliance & Platform Details
                                        </Title>

                                        <Grid>

                                            <Grid.Col span={6}>

                                                <Text fw={600}>
                                                    Privacy Policy
                                                </Text>

                                                <Anchor
                                                    href={selectedMerchant?.Compliance_and_MAF_schema_id?.Privacy_policy_link}
                                                    target="_blank"
                                                >
                                                    {selectedMerchant?.Compliance_and_MAF_schema_id?.Privacy_policy_link || "-"}
                                                </Anchor>

                                            </Grid.Col>

                                            <Grid.Col span={6}>

                                                <Text fw={600}>
                                                    Terms & Conditions
                                                </Text>

                                                <Anchor
                                                    href={selectedMerchant?.Compliance_and_MAF_schema_id?.Terms_and_conditions_link}
                                                    target="_blank"
                                                >
                                                    {selectedMerchant?.Compliance_and_MAF_schema_id?.Terms_and_conditions_link || "-"}
                                                </Anchor>

                                            </Grid.Col>

                                            <Grid.Col span={6}>

                                                <Text fw={600}>
                                                    Refund Policy
                                                </Text>

                                                <Anchor
                                                    href={selectedMerchant?.Compliance_and_MAF_schema_id?.Refund_policy_link}
                                                    target="_blank"
                                                >
                                                    {selectedMerchant?.Compliance_and_MAF_schema_id?.Refund_policy_link || "-"}
                                                </Anchor>

                                            </Grid.Col>

                                            <Grid.Col span={6}>

                                                <Text fw={600}>
                                                    Website
                                                </Text>

                                                <Anchor
                                                    href={selectedMerchant?.Compliance_and_MAF_schema_id?.Web_portal_link}
                                                    target="_blank"
                                                >
                                                    {selectedMerchant?.Compliance_and_MAF_schema_id?.Web_portal_link || "-"}
                                                </Anchor>

                                            </Grid.Col>

                                            <Grid.Col span={6}>

                                                <Text fw={600}>
                                                    Mobile Application
                                                </Text>

                                                <Anchor
                                                    href={selectedMerchant?.Compliance_and_MAF_schema_id?.Mobile_application_link}
                                                    target="_blank"
                                                >
                                                    {selectedMerchant?.Compliance_and_MAF_schema_id?.Mobile_application_link || "-"}
                                                </Anchor>

                                            </Grid.Col>

                                            <Grid.Col span={6}>

                                                <Text fw={600}>
                                                    Credentials for Verification
                                                </Text>

                                                <Text>
                                                    {selectedMerchant?.Compliance_and_MAF_schema_id?.Credentials_for_verification || "-"}
                                                </Text>

                                            </Grid.Col>

                                        </Grid>

                                    </Paper>

                                    {/* ===================================== */}
                                    {/* SERVICE DETAILS */}
                                    {/* ===================================== */}

                                    <Paper
                                        withBorder
                                        radius="md"
                                        p="lg"
                                    >

                                        <Group
                                            justify="space-between"
                                            mb="lg"
                                        >

                                            <Title order={4}>
                                                Service Wise Business Details
                                            </Title>

                                            <Badge size="lg">

                                                {selectedMerchant?.Compliance_and_MAF_schema_id?.Services_opted_in_details?.length}
                                                {" "}
                                                Services

                                            </Badge>

                                        </Group>

                                        <Table
                                            striped
                                            highlightOnHover
                                            withTableBorder
                                            withColumnBorders
                                        >

                                            <Table.Thead>

                                                <Table.Tr>

                                                    <Table.Th>S.No</Table.Th>

                                                    <Table.Th>Service</Table.Th>

                                                    <Table.Th>Use Case</Table.Th>

                                                    <Table.Th>Daily Txn</Table.Th>

                                                    <Table.Th>Monthly Business</Table.Th>

                                                    <Table.Th>Min Ticket</Table.Th>

                                                    <Table.Th>Max Ticket</Table.Th>

                                                    <Table.Th>Avg Ticket</Table.Th>

                                                </Table.Tr>

                                            </Table.Thead>

                                            <Table.Tbody>

                                                {selectedMerchant
                                                    ?.Compliance_and_MAF_schema_id
                                                    ?.Services_opted_in_details
                                                    ?.map((service, index) => (

                                                        <Table.Tr key={index}>

                                                            <Table.Td>
                                                                {index + 1}
                                                            </Table.Td>

                                                            <Table.Td>

                                                                <Badge
                                                                    variant="light"
                                                                >
                                                                    {service.Service_name?.join(", ")}
                                                                </Badge>

                                                            </Table.Td>

                                                            <Table.Td>
                                                                {service.Use_case_of_this_service}
                                                            </Table.Td>

                                                            <Table.Td>
                                                                {service.Expected_daily_transaction}
                                                            </Table.Td>

                                                            <Table.Td>
                                                                ₹ {service.Expected_monthly_business_for_this_service?.toLocaleString()}
                                                            </Table.Td>

                                                            <Table.Td>
                                                                ₹ {service.Min_ticket_size?.toLocaleString()}
                                                            </Table.Td>

                                                            <Table.Td>
                                                                ₹ {service.Max_ticket_size?.toLocaleString()}
                                                            </Table.Td>

                                                            <Table.Td>
                                                                ₹ {service.Average_ticket_size?.toLocaleString()}
                                                            </Table.Td>

                                                        </Table.Tr>

                                                    ))}

                                            </Table.Tbody>

                                        </Table>

                                    </Paper>

                                </Stack>

                            </Tabs.Panel>

                            <Tabs.Panel value="due" pt="md">

                                <Stack>

                                    {/* ========================================== */}
                                    {/* BUSINESS INFORMATION */}
                                    {/* ========================================== */}

                                    <Paper
                                        withBorder
                                        radius="md"
                                        p="lg"
                                    >

                                        <Title order={4} mb="lg">
                                            Business Information
                                        </Title>

                                        <Grid>

                                            <Grid.Col span={3}>
                                                <Text fw={600}>Registered Company</Text>
                                                <Text>
                                                    {selectedMerchant?.Merchant_due_deligence_schema_id?.Registered_Name_of_Company}
                                                </Text>
                                            </Grid.Col>

                                            <Grid.Col span={3}>
                                                <Text fw={600}>Constitution</Text>
                                                <Badge color="blue">
                                                    {selectedMerchant?.Merchant_due_deligence_schema_id?.Constitution}
                                                </Badge>
                                            </Grid.Col>

                                            <Grid.Col span={3}>
                                                <Text fw={600}>PAN</Text>
                                                <Text>
                                                    {selectedMerchant?.Merchant_due_deligence_schema_id?.PAN}
                                                </Text>
                                            </Grid.Col>

                                            <Grid.Col span={3}>
                                                <Text fw={600}>GST</Text>
                                                <Text>
                                                    {selectedMerchant?.Merchant_due_deligence_schema_id?.GST}
                                                </Text>
                                            </Grid.Col>

                                            <Grid.Col span={3}>
                                                <Text fw={600}>CIN</Text>
                                                <Text>
                                                    {selectedMerchant?.Merchant_due_deligence_schema_id?.CIN}
                                                </Text>
                                            </Grid.Col>

                                            <Grid.Col span={3}>
                                                <Text fw={600}>Date of Incorporation</Text>
                                                <Text>
                                                    {selectedMerchant?.Merchant_due_deligence_schema_id?.Date_of_Incorporation}
                                                </Text>
                                            </Grid.Col>

                                            <Grid.Col span={4}>
                                                <Text fw={600}>Registered Office</Text>
                                                <Text>
                                                    {selectedMerchant?.Merchant_due_deligence_schema_id?.Registered_Office_Address}
                                                </Text>
                                            </Grid.Col>

                                            <Grid.Col span={3}>
                                                <Text fw={600}>Annual Turnover</Text>
                                                <Text>
                                                    ₹ {selectedMerchant?.Merchant_due_deligence_schema_id?.Annual_Business_Turnover_In_crorers} Crores
                                                </Text>
                                            </Grid.Col>

                                            <Grid.Col span={3}>
                                                <Text fw={600}>Expected Monthly Processing</Text>
                                                <Text>
                                                    ₹ {selectedMerchant?.Merchant_due_deligence_schema_id?.Proposed_monthly_transaction_value_in_crores_to_be_processed_through} Crores
                                                </Text>
                                            </Grid.Col>

                                        </Grid>

                                    </Paper>

                                    {/* ========================================== */}
                                    {/* BUSINESS MODEL */}
                                    {/* ========================================== */}

                                    <Paper
                                        withBorder
                                        radius="md"
                                        p="lg"
                                    >

                                        <Title order={4} mb="lg">
                                            Business Model
                                        </Title>

                                        <Grid>

                                            <Grid.Col span={3}>
                                                <Text fw={600}>Mode of Business</Text>
                                                <Badge>
                                                    {selectedMerchant?.Merchant_due_deligence_schema_id?.Mode_of_Business}
                                                </Badge>
                                            </Grid.Col>

                                            <Grid.Col span={3}>
                                                <Text fw={600}>Products / Services</Text>
                                                <Text>
                                                    {selectedMerchant?.Merchant_due_deligence_schema_id?.Products_or_Service_to_be_sold_by_the_merchant}
                                                </Text>
                                            </Grid.Col>

                                            <Grid.Col span={3}>
                                                <Text fw={600}>Nature of Business</Text>
                                                <Text>
                                                    {selectedMerchant?.Merchant_due_deligence_schema_id?.Nature_of_Business_Use_case}
                                                </Text>
                                            </Grid.Col>

                                            <Grid.Col span={3}>
                                                <Text fw={600}>Website</Text>

                                                <Anchor
                                                    href={selectedMerchant?.Merchant_due_deligence_schema_id?.Functional_website_link}
                                                    target="_blank"
                                                >
                                                    {selectedMerchant?.Merchant_due_deligence_schema_id?.Functional_website_link}
                                                </Anchor>

                                            </Grid.Col>

                                            <Grid.Col span={3}>
                                                <Text fw={600}>Mobile App</Text>

                                                <Anchor
                                                    href={selectedMerchant?.Merchant_due_deligence_schema_id?.Mobile_application_details}
                                                    target="_blank"
                                                >
                                                    {selectedMerchant?.Merchant_due_deligence_schema_id?.Mobile_application_details}
                                                </Anchor>

                                            </Grid.Col>

                                            <Grid.Col span={12}>

                                                <Text fw={600} mb="sm">
                                                    Requested Services
                                                </Text>

                                                <Group>

                                                    {selectedMerchant?.Merchant_due_deligence_schema_id?.Merchant_services_required?.map((service, index) => (

                                                        <Badge
                                                            key={index}
                                                            variant="light"
                                                        >
                                                            {service.replaceAll("_", " ")}
                                                        </Badge>

                                                    ))}

                                                </Group>

                                            </Grid.Col>

                                        </Grid>

                                    </Paper>

                                    {/* ========================================== */}
                                    {/* DIRECTORS / PROMOTERS */}
                                    {/* ========================================== */}

                                    <Paper
                                        withBorder
                                        radius="md"
                                        p="lg"
                                    >

                                        <Title order={4} mb="lg">
                                            Directors / Promoters
                                        </Title>

                                        <Table
                                            striped
                                            withTableBorder
                                            withColumnBorders
                                        >

                                            <Table.Thead>

                                                <Table.Tr>

                                                    <Table.Th>Name</Table.Th>

                                                    <Table.Th>DIN</Table.Th>

                                                    <Table.Th>Promoter</Table.Th>

                                                    <Table.Th>Authorized Signatory</Table.Th>

                                                </Table.Tr>

                                            </Table.Thead>

                                            <Table.Tbody>

                                                {selectedMerchant?.Merchant_due_deligence_schema_id?.Directors_of_Company?.map((director, index) => {

                                                    const promoter =
                                                        selectedMerchant?.Merchant_due_deligence_schema_id?.Promoters_of_Company?.find(
                                                            p => p.Promoter_name === director.Director_name
                                                        );

                                                    const auth =
                                                        selectedMerchant?.Merchant_due_deligence_schema_id?.Authorised_Signatory?.find(
                                                            a => a.Authorised_name === director.Director_name
                                                        );

                                                    return (

                                                        <Table.Tr key={index}>

                                                            <Table.Td>
                                                                {director.Director_name}
                                                            </Table.Td>

                                                            <Table.Td>
                                                                {director.Director_DIN_number}
                                                            </Table.Td>

                                                            <Table.Td>

                                                                {promoter
                                                                    ?
                                                                    <Badge color="green">
                                                                        Yes
                                                                    </Badge>
                                                                    :
                                                                    <Badge color="gray">
                                                                        No
                                                                    </Badge>}

                                                            </Table.Td>

                                                            <Table.Td>

                                                                {auth
                                                                    ?
                                                                    <Badge color="blue">
                                                                        Authorized
                                                                    </Badge>
                                                                    :
                                                                    "-"}

                                                            </Table.Td>

                                                        </Table.Tr>

                                                    );

                                                })}

                                            </Table.Tbody>

                                        </Table>

                                    </Paper>

                                    {/* ========================================== */}
                                    {/* TRANSACTION PROFILE */}
                                    {/* ========================================== */}

                                    <Paper
                                        withBorder
                                        radius="md"
                                        p="lg"
                                    >

                                        <Title order={4} mb="lg">
                                            Transaction Profile
                                        </Title>

                                        <Table
                                            striped
                                            withTableBorder
                                            withColumnBorders
                                        >

                                            <Table.Thead>

                                                <Table.Tr>

                                                    <Table.Th>Service</Table.Th>

                                                    <Table.Th>Daily Txn</Table.Th>

                                                    <Table.Th>Monthly Business</Table.Th>

                                                    <Table.Th>Min Ticket</Table.Th>

                                                    <Table.Th>Max Ticket</Table.Th>

                                                    <Table.Th>Average Ticket</Table.Th>

                                                </Table.Tr>

                                            </Table.Thead>

                                            <Table.Tbody>

                                                {selectedMerchant?.Merchant_due_deligence_schema_id?.Transaction_Ticket_Size?.map((item, index) => (

                                                    <Table.Tr key={index}>

                                                        <Table.Td>
                                                            {item.Service_name.join(", ")}
                                                        </Table.Td>

                                                        <Table.Td>
                                                            {item.Expected_daily_transaction}
                                                        </Table.Td>

                                                        <Table.Td>
                                                            ₹ {item.Expected_monthly_business_for_this_service.toLocaleString()}
                                                        </Table.Td>

                                                        <Table.Td>
                                                            ₹ {item.Min_ticket_size.toLocaleString()}
                                                        </Table.Td>

                                                        <Table.Td>
                                                            ₹ {item.Max_ticket_size.toLocaleString()}
                                                        </Table.Td>

                                                        <Table.Td>
                                                            ₹ {item.Average_ticket_size.toLocaleString()}
                                                        </Table.Td>

                                                    </Table.Tr>

                                                ))}

                                            </Table.Tbody>

                                        </Table>

                                    </Paper>

                                    {/* ========================================== */}
                                    {/* DUE DELIGENCE DOCUMENTD CHECK LIST */}
                                    {/* ========================================== */}
                                    <Paper
                                        withBorder
                                        p="lg"
                                        radius="md"
                                    >

                                        <Title order={4} mb="lg">
                                            KYC & Compliance Documents Checklist
                                        </Title>

                                        <Text size="sm" c="dimmed" mb="md">
                                            Review the documents declared by the merchant during Due Diligence.
                                        </Text>

                                        <Table
                                            withTableBorder
                                            withColumnBorders
                                            striped
                                            highlightOnHover
                                        >

                                            <Table.Thead>

                                                <Table.Tr>

                                                    <Table.Th>S.No</Table.Th>

                                                    <Table.Th>Document Name</Table.Th>

                                                    <Table.Th>Required</Table.Th>

                                                </Table.Tr>

                                            </Table.Thead>

                                            <Table.Tbody>

                                                {[
                                                    {
                                                        name: "Company PAN",
                                                        value: selectedMerchant?.Merchant_due_deligence_schema_id?.Company_PAN,
                                                    },
                                                    {
                                                        name: "Company GST",
                                                        value: selectedMerchant?.Merchant_due_deligence_schema_id?.Company_GST,
                                                    },
                                                    {
                                                        name: "Certificate of Incorporation",
                                                        value: selectedMerchant?.Merchant_due_deligence_schema_id?.Certificate_of_incorporation,
                                                    },
                                                    {
                                                        name: "Article of Association",
                                                        value: selectedMerchant?.Merchant_due_deligence_schema_id?.Article_of_association,
                                                    },
                                                    {
                                                        name: "Memorandum of Association",
                                                        value: selectedMerchant?.Merchant_due_deligence_schema_id?.Memorandum_of_Association,
                                                    },
                                                    {
                                                        name: "Cancelled Cheque",
                                                        value: selectedMerchant?.Merchant_due_deligence_schema_id?.Cancelled_Cheque,
                                                    },
                                                    {
                                                        name: "Board Resolution",
                                                        value: selectedMerchant?.Merchant_due_deligence_schema_id?.Board_Resolution_for_Authorised_Signatory,
                                                    },
                                                    {
                                                        name: "Merchant Criminal Undertaking",
                                                        value: selectedMerchant?.Merchant_due_deligence_schema_id?.Merchant_Criminal_Undertaking,
                                                    },
                                                    {
                                                        name: "MCA Data",
                                                        value: selectedMerchant?.Merchant_due_deligence_schema_id?.MCA_Data,
                                                    },
                                                    {
                                                        name: "MSME Certificate",
                                                        value: selectedMerchant?.Merchant_due_deligence_schema_id?.MSME_Certificate,
                                                    },
                                                    {
                                                        name: "Balance Sheet (Past 2 Years)",
                                                        value: selectedMerchant?.Merchant_due_deligence_schema_id?.Balance_Sheet_for_Past_2_Financial_Years,
                                                    },
                                                    {
                                                        name: "GST Returns (Past 2 Years)",
                                                        value: selectedMerchant?.Merchant_due_deligence_schema_id?.GST_Returns_for_Past_2_Financial_Years,
                                                    },
                                                    {
                                                        name: "Bank Statement (Last 3 Months)",
                                                        value: selectedMerchant?.Merchant_due_deligence_schema_id?.Bank_Statement_last_3_months,
                                                    },
                                                    {
                                                        name: "Office Photo with Company Board",
                                                        value: selectedMerchant?.Merchant_due_deligence_schema_id?.Office_Photo_with_company_board_disptay,
                                                    },
                                                    {
                                                        name: "Geo Tagged Office Photo",
                                                        value: selectedMerchant?.Merchant_due_deligence_schema_id?.Photo_of_Authorised_Signatory_Office_with_geo_location,
                                                    },
                                                    {
                                                        name: "Authorized Signatory KYC",
                                                        value: selectedMerchant?.Merchant_due_deligence_schema_id?.Aadhar_and_PAN_and_Photo_of_Authorised_Signatory_for_KYC,
                                                    },
                                                    {
                                                        name: "All Directors KYC",
                                                        value: selectedMerchant?.Merchant_due_deligence_schema_id?.Aadhar_and_PAN_and_Photo_of_all_Directors_for_KYC,
                                                    },
                                                    {
                                                        name: "All Promoters PAN & Aadhaar",
                                                        value: selectedMerchant?.Merchant_due_deligence_schema_id?.Aadhar_and_PAN_of_all_Promoters_for_KYC,
                                                    },
                                                    {
                                                        name: "List of Directors on Company Letterhead",
                                                        value: selectedMerchant?.Merchant_due_deligence_schema_id?.List_of_Directors_on_Company_Letter_Head,
                                                    },
                                                    {
                                                        name: "List of Promoters on Company Letterhead",
                                                        value: selectedMerchant?.Merchant_due_deligence_schema_id?.List_of_Promoters_on_Company_Letter_Head,
                                                    },
                                                    {
                                                        name: "Invoice Generated Through Merchant Portal",
                                                        value: selectedMerchant?.Merchant_due_deligence_schema_id?.invoice_Generated_for_a_Customer_Through_Merchants_Site_Application,
                                                    },
                                                ].map((doc, index) => (

                                                    <Table.Tr key={index}>

                                                        <Table.Td>
                                                            {index + 1}
                                                        </Table.Td>

                                                        <Table.Td>
                                                            {doc.name}
                                                        </Table.Td>

                                                        <Table.Td>

                                                            <Badge
                                                                color={
                                                                    doc.value === "Yes"
                                                                        ? "green"
                                                                        : "red"
                                                                }
                                                                variant="light"
                                                            >

                                                                {doc.value}

                                                            </Badge>

                                                        </Table.Td>

                                                    </Table.Tr>

                                                ))}

                                            </Table.Tbody>

                                        </Table>

                                    </Paper>

                                </Stack>

                            </Tabs.Panel>

                            <Tabs.Panel value="board" pt="md">

                                <Stack>
                                    {/* =============================== */}
                                    {/* BASIC DETAILS */}
                                    {/* =============================== */}

                                    <Paper
                                        withBorder
                                        p="lg"
                                        radius="md"
                                    >

                                        <Title order={4} mb="lg">
                                            Board Resolution Details
                                        </Title>

                                        <Grid>

                                            <Grid.Col span={4}>

                                                <Text fw={600}>
                                                    Resolution Title
                                                </Text>

                                                <Text>
                                                    {
                                                        selectedMerchant
                                                            ?.Board_of_resolution_schema_id
                                                            ?.Resolution_title
                                                    }
                                                </Text>

                                            </Grid.Col>

                                            <Grid.Col span={4}>

                                                <Text fw={600}>
                                                    Meeting Date
                                                </Text>

                                                <Text>
                                                    {
                                                        selectedMerchant
                                                            ?.Board_of_resolution_schema_id
                                                            ?.Meeting_date
                                                    }
                                                </Text>

                                            </Grid.Col>

                                            <Grid.Col span={4}>

                                                <Text fw={600}>
                                                    Company Name
                                                </Text>

                                                <Text>
                                                    {
                                                        selectedMerchant
                                                            ?.Board_of_resolution_schema_id
                                                            ?.Registered_Name_of_Company
                                                    }
                                                </Text>

                                            </Grid.Col>

                                            <Grid.Col span={12}>

                                                <Text fw={600}>
                                                    Registered Office
                                                </Text>

                                                <Text>
                                                    {
                                                        selectedMerchant
                                                            ?.Board_of_resolution_schema_id
                                                            ?.Registered_Office_Address
                                                    }
                                                </Text>

                                            </Grid.Col>

                                        </Grid>

                                    </Paper>

                                    {/* =============================== */}
                                    {/* DIRECTORS */}
                                    {/* =============================== */}

                                    <Paper
                                        withBorder
                                        p="lg"
                                        radius="md"
                                    >

                                        <Title order={5} mb="md">
                                            Directors
                                        </Title>

                                        <Table
                                            withTableBorder
                                            withColumnBorders
                                            striped
                                        >

                                            <Table.Thead>

                                                <Table.Tr>

                                                    <Table.Th>
                                                        #
                                                    </Table.Th>

                                                    <Table.Th>
                                                        Director Name
                                                    </Table.Th>

                                                    <Table.Th>
                                                        DIN Number
                                                    </Table.Th>

                                                </Table.Tr>

                                            </Table.Thead>

                                            <Table.Tbody>

                                                {
                                                    selectedMerchant
                                                        ?.Board_of_resolution_schema_id
                                                        ?.Directors_of_Company
                                                        ?.map((director, index) => (

                                                            <Table.Tr key={index}>

                                                                <Table.Td>
                                                                    {index + 1}
                                                                </Table.Td>

                                                                <Table.Td>
                                                                    {director.Director_name}
                                                                </Table.Td>

                                                                <Table.Td>
                                                                    {director.Director_DIN_number}
                                                                </Table.Td>

                                                            </Table.Tr>

                                                        ))
                                                }

                                            </Table.Tbody>

                                        </Table>

                                    </Paper>

                                    {/* =============================== */}
                                    {/* AUTHORIZED SIGNATORY */}
                                    {/* =============================== */}

                                    <Paper
                                        withBorder
                                        p="lg"
                                        radius="md"
                                    >

                                        <Title order={5} mb="md">
                                            Authorized Signatory
                                        </Title>

                                        <Table
                                            withTableBorder
                                            withColumnBorders
                                            striped
                                        >

                                            <Table.Thead>

                                                <Table.Tr>

                                                    <Table.Th>
                                                        #
                                                    </Table.Th>

                                                    <Table.Th>
                                                        Name
                                                    </Table.Th>

                                                    <Table.Th>
                                                        DIN
                                                    </Table.Th>

                                                    <Table.Th>
                                                        Mobile
                                                    </Table.Th>

                                                    <Table.Th>
                                                        Email
                                                    </Table.Th>

                                                    <Table.Th>
                                                        Share %
                                                    </Table.Th>

                                                </Table.Tr>

                                            </Table.Thead>

                                            <Table.Tbody>

                                                {
                                                    selectedMerchant
                                                        ?.Board_of_resolution_schema_id
                                                        ?.Authorised_Signatory
                                                        ?.map((person, index) => (

                                                            <Table.Tr key={index}>

                                                                <Table.Td>
                                                                    {index + 1}
                                                                </Table.Td>

                                                                <Table.Td>
                                                                    {person.Authorised_name}
                                                                </Table.Td>

                                                                <Table.Td>
                                                                    {person.Authorised_DIN_number}
                                                                </Table.Td>

                                                                <Table.Td>
                                                                    {person.Authorised_mobile_number}
                                                                </Table.Td>

                                                                <Table.Td>
                                                                    {person.Authorised_email}
                                                                </Table.Td>

                                                                <Table.Td>
                                                                    {person.Authorised_Share_perecentage}%
                                                                </Table.Td>

                                                            </Table.Tr>

                                                        ))
                                                }

                                            </Table.Tbody>

                                        </Table>

                                    </Paper>

                                    {/* =============================== */}
                                    {/* RESOLUTION CONTENT */}
                                    {/* =============================== */}

                                    <Paper
                                        withBorder
                                        p="lg"
                                        radius="md"
                                    >

                                        <Group
                                            justify="space-between"
                                            mb="md"
                                        >

                                            <Title order={5}>
                                                Resolution Preview
                                            </Title>

                                            <Button
                                                variant="light"
                                            >
                                                Download Resolution
                                            </Button>

                                        </Group>

                                        <Paper
                                            withBorder
                                            p="xl"
                                            radius="md"
                                            style={{
                                                background: "#fff",
                                                maxHeight: 700,
                                                overflowY: "auto"
                                            }}
                                        >

                                            <div

                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        selectedMerchant
                                                            ?.Board_of_resolution_schema_id
                                                            ?.Resolution_content
                                                }}

                                            />

                                        </Paper>

                                    </Paper>

                                </Stack>

                            </Tabs.Panel>

                            <Tabs.Panel value="undertaking" pt="md">

                                <Stack>

                                    {/* =============================== */}
                                    {/* BASIC DETAILS */}
                                    {/* =============================== */}

                                    <Paper
                                        withBorder
                                        p="lg"
                                        radius="md"
                                    >

                                        <Title order={4} mb="lg">
                                            Merchant Criminal Undertaking
                                        </Title>

                                        <Grid>

                                            <Grid.Col span={4}>

                                                <Text fw={600}>
                                                    Document Title
                                                </Text>

                                                <Text>
                                                    {
                                                        selectedMerchant
                                                            ?.Merchant_criminal_undertaking_schema_id
                                                            ?.Resolution_title
                                                    }
                                                </Text>

                                            </Grid.Col>

                                            <Grid.Col span={4}>

                                                <Text fw={600}>
                                                    Undertaking Date
                                                </Text>

                                                <Text>
                                                    {
                                                        selectedMerchant
                                                            ?.Merchant_criminal_undertaking_schema_id
                                                            ?.undertakingDate
                                                    }
                                                </Text>

                                            </Grid.Col>

                                            <Grid.Col span={4}>

                                                <Text fw={600}>
                                                    Company Name
                                                </Text>

                                                <Text>
                                                    {
                                                        selectedMerchant
                                                            ?.Merchant_criminal_undertaking_schema_id
                                                            ?.Registered_Name_of_Company
                                                    }
                                                </Text>

                                            </Grid.Col>

                                            <Grid.Col span={12}>

                                                <Text fw={600}>
                                                    Registered Office
                                                </Text>

                                                <Text>
                                                    {
                                                        selectedMerchant
                                                            ?.Merchant_criminal_undertaking_schema_id
                                                            ?.Registered_Office_Address
                                                    }
                                                </Text>

                                            </Grid.Col>

                                        </Grid>

                                    </Paper>

                                    {/* =============================== */}
                                    {/* AUTHORIZED SIGNATORY */}
                                    {/* =============================== */}

                                    <Paper
                                        withBorder
                                        p="lg"
                                        radius="md"
                                    >

                                        <Title order={5} mb="md">
                                            Authorized Signatory
                                        </Title>

                                        <Table
                                            withTableBorder
                                            withColumnBorders
                                            striped
                                        >

                                            <Table.Thead>

                                                <Table.Tr>

                                                    <Table.Th>#</Table.Th>

                                                    <Table.Th>Name</Table.Th>

                                                    <Table.Th>DIN</Table.Th>

                                                    <Table.Th>Mobile</Table.Th>

                                                    <Table.Th>Email</Table.Th>

                                                    <Table.Th>Share %</Table.Th>

                                                </Table.Tr>

                                            </Table.Thead>

                                            <Table.Tbody>

                                                {
                                                    selectedMerchant
                                                        ?.Merchant_criminal_undertaking_schema_id
                                                        ?.Authorised_Signatory
                                                        ?.map((person, index) => (

                                                            <Table.Tr key={index}>

                                                                <Table.Td>
                                                                    {index + 1}
                                                                </Table.Td>

                                                                <Table.Td>
                                                                    {person.Authorised_name}
                                                                </Table.Td>

                                                                <Table.Td>
                                                                    {person.Authorised_DIN_number}
                                                                </Table.Td>

                                                                <Table.Td>
                                                                    {person.Authorised_mobile_number}
                                                                </Table.Td>

                                                                <Table.Td>
                                                                    {person.Authorised_email}
                                                                </Table.Td>

                                                                <Table.Td>
                                                                    {person.Authorised_Share_perecentage}%
                                                                </Table.Td>

                                                            </Table.Tr>

                                                        ))
                                                }

                                            </Table.Tbody>

                                        </Table>

                                    </Paper>

                                    {/* =============================== */}
                                    {/* UNDERTAKING DOCUMENT */}
                                    {/* =============================== */}

                                    <Paper
                                        withBorder
                                        p="lg"
                                        radius="md"
                                    >

                                        <Group
                                            justify="space-between"
                                            mb="md"
                                        >

                                            <Title order={5}>
                                                Undertaking Preview
                                            </Title>

                                            <Button
                                                variant="light"
                                            >
                                                Download Document
                                            </Button>

                                        </Group>

                                        <Paper
                                            withBorder
                                            radius="md"
                                            p="xl"
                                            style={{
                                                background: "#fff",
                                                maxHeight: 700,
                                                overflowY: "auto"
                                            }}
                                        >

                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        selectedMerchant
                                                            ?.Merchant_criminal_undertaking_schema_id
                                                            ?.Resolution_content
                                                }}
                                            />

                                        </Paper>

                                    </Paper>

                                </Stack>

                            </Tabs.Panel>

                            <Tabs.Panel value="documents" pt="md">

                                <Stack>

                                    {/* ===================================== */}
                                    {/* HEADER */}
                                    {/* ===================================== */}

                                    <Paper
                                        withBorder
                                        p="lg"
                                        radius="md"
                                    >

                                        <Title order={4}>
                                            Uploaded Documents
                                        </Title>

                                        <Text c="dimmed" mt={5}>
                                            Verify all documents uploaded by the merchant.
                                        </Text>

                                        <Grid mt="md">

                                            <Grid.Col span={4}>

                                                <Text fw={600}>
                                                    Company Name
                                                </Text>

                                                <Text>
                                                    {selectedMerchant?.Upload_documents_schema_id?.Registered_Name_of_Company}
                                                </Text>

                                            </Grid.Col>

                                            <Grid.Col span={4}>

                                                <Text fw={600}>
                                                    PAN Number
                                                </Text>

                                                <Text>
                                                    {selectedMerchant?.Upload_documents_schema_id?.Registered_PAN_Number}
                                                </Text>

                                            </Grid.Col>

                                            <Grid.Col span={4}>

                                                <Text fw={600}>
                                                    GST Number
                                                </Text>

                                                <Text>
                                                    {selectedMerchant?.Upload_documents_schema_id?.Registered_GST_Number}
                                                </Text>

                                            </Grid.Col>

                                            <Grid.Col span={4}>

                                                <Text fw={600}>
                                                    Upload Date
                                                </Text>

                                                <Text>
                                                    {
                                                        new Date(
                                                            selectedMerchant?.Upload_documents_schema_id?.upload_date
                                                        ).toLocaleString()
                                                    }
                                                </Text>

                                            </Grid.Col>

                                            <Grid.Col span={4}>

                                                <Text fw={600}>
                                                    Total Documents
                                                </Text>

                                                <Badge
                                                    size="lg"
                                                    color="blue"
                                                >
                                                    {
                                                        selectedMerchant
                                                            ?.Upload_documents_schema_id
                                                            ?.uploaded_documents
                                                            ?.length || 0
                                                    }
                                                </Badge>

                                            </Grid.Col>

                                        </Grid>

                                    </Paper>

                                    {/* ===================================== */}
                                    {/* DOCUMENTS TABLE */}
                                    {/* ===================================== */}

                                    <Paper
                                        withBorder
                                        p="lg"
                                        radius="md"
                                    >

                                        <Title
                                            order={5}
                                            mb="md"
                                        >
                                            Document List
                                        </Title>

                                        <Table
                                            withTableBorder
                                            withColumnBorders
                                            striped
                                            highlightOnHover
                                        >

                                            <Table.Thead>

                                                <Table.Tr>

                                                    <Table.Th>
                                                        #
                                                    </Table.Th>

                                                    <Table.Th>
                                                        Document Type
                                                    </Table.Th>

                                                    <Table.Th>
                                                        Original File
                                                    </Table.Th>

                                                    <Table.Th>
                                                        File Type
                                                    </Table.Th>

                                                    <Table.Th>
                                                        Size
                                                    </Table.Th>

                                                    <Table.Th>
                                                        Uploaded On
                                                    </Table.Th>

                                                    <Table.Th>
                                                        Action
                                                    </Table.Th>

                                                </Table.Tr>

                                            </Table.Thead>

                                            <Table.Tbody>

                                                {
                                                    selectedMerchant
                                                        ?.Upload_documents_schema_id
                                                        ?.uploaded_documents
                                                        ?.map((doc, index) => (

                                                            <Table.Tr key={doc._id}>

                                                                <Table.Td>

                                                                    {index + 1}

                                                                </Table.Td>

                                                                <Table.Td>

                                                                    <Badge
                                                                        variant="light"
                                                                    >
                                                                        {doc.document_name}
                                                                    </Badge>

                                                                </Table.Td>

                                                                <Table.Td>

                                                                    {doc.original_file_name}

                                                                </Table.Td>

                                                                <Table.Td>

                                                                    {doc.mime_type}

                                                                </Table.Td>

                                                                <Table.Td>

                                                                    {(doc.file_size / 1024 / 1024).toFixed(2)}
                                                                    {" "}MB

                                                                </Table.Td>

                                                                <Table.Td>

                                                                    {
                                                                        new Date(
                                                                            doc.uploaded_at
                                                                        ).toLocaleString()
                                                                    }

                                                                </Table.Td>

                                                                <Table.Td>

                                                                    <Group gap="xs">

                                                                        <Button
                                                                            size="xs"
                                                                            variant="filled"
                                                                            component="a"
                                                                            href={doc.google_drive_link}
                                                                            target="_blank"
                                                                        >

                                                                            View

                                                                        </Button>

                                                                        <Button
                                                                            size="xs"
                                                                            variant="light"
                                                                            color="green"
                                                                            component="a"
                                                                            href={`https://drive.google.com/uc?export=download&id=${doc.google_drive_file_id}`}
                                                                            target="_blank"
                                                                        >

                                                                            Download

                                                                        </Button>

                                                                    </Group>

                                                                </Table.Td>

                                                            </Table.Tr>

                                                        ))
                                                }

                                            </Table.Tbody>

                                        </Table>

                                    </Paper>

                                </Stack>

                            </Tabs.Panel>

                            <Tabs.Panel value="terms" pt="md">

                                <Stack>

                                    {/* ================================= */}
                                    {/* TERMS SUMMARY */}
                                    {/* ================================= */}

                                    <Paper
                                        withBorder
                                        p="lg"
                                        radius="md"
                                    >

                                        <Title order={4} mb="lg">
                                            Terms & Conditions
                                        </Title>

                                        <Grid>

                                            <Grid.Col span={4}>

                                                <Text fw={600}>
                                                    Authorized Signatory
                                                </Text>

                                                <Text>
                                                    {
                                                        selectedMerchant
                                                            ?.authorized_signatory_name
                                                    }
                                                </Text>

                                            </Grid.Col>

                                            <Grid.Col span={4}>

                                                <Text fw={600}>
                                                    Main Terms Accepted
                                                </Text>

                                                <Badge
                                                    color={
                                                        selectedMerchant?.accepted_main_terms
                                                            ? "green"
                                                            : "red"
                                                    }
                                                >
                                                    {
                                                        selectedMerchant?.accepted_main_terms
                                                            ? "Accepted"
                                                            : "Not Accepted"
                                                    }
                                                </Badge>

                                            </Grid.Col>

                                            <Grid.Col span={4}>

                                                <Text fw={600}>
                                                    Acceptance Date
                                                </Text>

                                                <Text>

                                                    {
                                                        new Date(
                                                            selectedMerchant
                                                                ?.accepted_main_terms_date
                                                        ).toLocaleString()
                                                    }

                                                </Text>

                                            </Grid.Col>

                                            <Grid.Col span={12} mt="md">

                                                <Alert
                                                    color="green"
                                                    variant="light"
                                                >

                                                    The merchant has confirmed that all information
                                                    submitted is correct and has accepted the
                                                    BOOM PAY TECHNOLOGY PVT. LTD.
                                                    Terms & Conditions.

                                                </Alert>

                                            </Grid.Col>

                                        </Grid>

                                    </Paper>

                                    {/* ================================= */}
                                    {/* SERVICES ACCEPTANCE */}
                                    {/* ================================= */}

                                    <Paper
                                        withBorder
                                        p="lg"
                                        radius="md"
                                    >

                                        <Group
                                            justify="space-between"
                                            mb="md"
                                        >

                                            <Title order={5}>
                                                Service-wise Acceptance
                                            </Title>

                                            <Badge
                                                size="lg"
                                                color="blue"
                                            >

                                                {
                                                    selectedMerchant
                                                        ?.accepted_services
                                                        ?.length
                                                } Services

                                            </Badge>

                                        </Group>

                                        <Table
                                            withTableBorder
                                            withColumnBorders
                                            striped
                                            highlightOnHover
                                        >

                                            <Table.Thead>

                                                <Table.Tr>

                                                    <Table.Th>
                                                        #
                                                    </Table.Th>

                                                    <Table.Th>
                                                        Service
                                                    </Table.Th>

                                                    <Table.Th>
                                                        Accepted
                                                    </Table.Th>

                                                    <Table.Th>
                                                        Accepted On
                                                    </Table.Th>

                                                </Table.Tr>

                                            </Table.Thead>

                                            <Table.Tbody>

                                                {
                                                    selectedMerchant
                                                        ?.accepted_services
                                                        ?.map((service, index) => (

                                                            <Table.Tr key={service._id}>

                                                                <Table.Td>

                                                                    {index + 1}

                                                                </Table.Td>

                                                                <Table.Td>

                                                                    <Badge
                                                                        variant="light"
                                                                    >
                                                                        {service.service_name}
                                                                    </Badge>

                                                                </Table.Td>

                                                                <Table.Td>

                                                                    <Badge
                                                                        color={
                                                                            service.is_accepted
                                                                                ? "green"
                                                                                : "red"
                                                                        }
                                                                    >

                                                                        {
                                                                            service.is_accepted
                                                                                ? "Accepted"
                                                                                : "Rejected"
                                                                        }

                                                                    </Badge>

                                                                </Table.Td>

                                                                <Table.Td>

                                                                    {
                                                                        new Date(
                                                                            service.accepted_at
                                                                        ).toLocaleString()
                                                                    }

                                                                </Table.Td>

                                                            </Table.Tr>

                                                        ))
                                                }

                                            </Table.Tbody>

                                        </Table>

                                    </Paper>

                                    {/* ================================= */}
                                    {/* DECLARATION */}
                                    {/* ================================= */}

                                    <Paper
                                        withBorder
                                        p="lg"
                                        radius="md"
                                    >

                                        <Title
                                            order={5}
                                            mb="md"
                                        >
                                            Merchant Declaration
                                        </Title>

                                        <Alert
                                            color="blue"
                                            variant="light"
                                        >

                                            <Text>

                                                <strong>
                                                    Authorized Signatory:
                                                </strong>

                                                {" "}

                                                {
                                                    selectedMerchant
                                                        ?.authorized_signatory_name
                                                }

                                            </Text>

                                            <Space h="md" />

                                            <Text>

                                                The merchant has declared that all information,
                                                documents and details submitted during the onboarding
                                                process are true, correct and up-to-date and has
                                                accepted all applicable BOOM PAY TECHNOLOGY PVT. LTD.
                                                Terms & Conditions for the selected services.

                                            </Text>

                                        </Alert>

                                    </Paper>

                                </Stack>

                            </Tabs.Panel>

                            <Tabs.Panel value="remarks" pt="md">

                                <Stack>

                                    {/* =============================== */}
                                    {/* CURRENT STATUS */}
                                    {/* =============================== */}

                                    <Paper
                                        withBorder
                                        p="lg"
                                        radius="md"
                                    >

                                        <Group justify="space-between">

                                            <div>

                                                <Title order={4}>
                                                    Verification Status
                                                </Title>

                                                <Text c="dimmed">
                                                    Review progress of this onboarding application.
                                                </Text>

                                            </div>

                                            <Badge
                                                size="lg"
                                                color={getStatusColor(selectedMerchant?.onboarding_status)}
                                            >
                                                {selectedMerchant?.onboarding_status}
                                            </Badge>

                                        </Group>

                                        <Divider my="md" />

                                        <Grid>

                                            <Grid.Col span={4}>

                                                <Text fw={600}>
                                                    Current Verification Step
                                                </Text>

                                                <Badge size="lg">
                                                    Step {selectedMerchant?.verification_step}
                                                </Badge>

                                            </Grid.Col>

                                            <Grid.Col span={4}>

                                                <Text fw={600}>
                                                    Submitted On
                                                </Text>

                                                <Text>
                                                    {new Date(selectedMerchant?.createdAt).toLocaleString()}
                                                </Text>

                                            </Grid.Col>

                                            <Grid.Col span={4}>

                                                <Text fw={600}>
                                                    Last Updated
                                                </Text>

                                                <Text>
                                                    {new Date(selectedMerchant?.updatedAt).toLocaleString()}
                                                </Text>

                                            </Grid.Col>

                                        </Grid>

                                    </Paper>

                                    {/* =============================== */}
                                    {/* AO TEAM */}
                                    {/* =============================== */}

                                    <Paper withBorder p="lg">

                                        <Title order={5} mb="md">
                                            AO Verification
                                        </Title>

                                        <Textarea
                                            label="AO Remarks"
                                            placeholder="Enter AO verification remarks..."
                                            minRows={4}
                                            value={aoRemarks}
                                            onChange={(e) =>
                                                setAoRemarks(e.target.value)
                                            }
                                        />

                                        <Space h="md" />

                                        <Text fw={600}>
                                            Previous Remarks
                                        </Text>

                                        <Paper
                                            mt="xs"
                                            p="sm"
                                            bg="gray.0"
                                        >

                                            {selectedMerchant?.onboard_remark?.[0]?.ao_remarks
                                                ? selectedMerchant.onboard_remark[0].ao_remarks
                                                : "No remarks added yet."}

                                        </Paper>

                                    </Paper>

                                    {/* =============================== */}
                                    {/* ONBOARDING TEAM */}
                                    {/* =============================== */}

                                    <Paper withBorder p="lg">

                                        <Title order={5} mb="md">
                                            Onboarding Team
                                        </Title>

                                        <Textarea
                                            label="Onboarding Remarks"
                                            placeholder="Enter onboarding team remarks..."
                                            minRows={4}
                                            value={onboardRemarks}
                                            onChange={(e) =>
                                                setOnboardRemarks(e.target.value)
                                            }
                                        />

                                        <Space h="md" />

                                        <Text fw={600}>
                                            Previous Remarks
                                        </Text>

                                        <Paper
                                            mt="xs"
                                            p="sm"
                                            bg="gray.0"
                                        >

                                            {selectedMerchant?.onboard_remark?.[0]?.onboardteam_remarks ||
                                                "No remarks added yet."}

                                        </Paper>

                                    </Paper>

                                    {/* =============================== */}
                                    {/* LEGAL TEAM */}
                                    {/* =============================== */}

                                    <Paper withBorder p="lg">

                                        <Title order={5} mb="md">
                                            Legal Verification
                                        </Title>

                                        <Textarea
                                            label="Legal Remarks"
                                            placeholder="Enter legal verification remarks..."
                                            minRows={4}
                                            value={legalRemarks}
                                            onChange={(e) =>
                                                setLegalRemarks(e.target.value)
                                            }
                                        />

                                        <Space h="md" />

                                        <Text fw={600}>
                                            Previous Remarks
                                        </Text>

                                        <Paper
                                            mt="xs"
                                            p="sm"
                                            bg="gray.0"
                                        >

                                            {selectedMerchant?.onboard_remark?.[0]?.leagalteam_remarks ||
                                                "No remarks added yet."}

                                        </Paper>

                                    </Paper>

                                    {/* =============================== */}
                                    {/* REVIEW TEAM */}
                                    {/* =============================== */}

                                    <Paper withBorder p="lg">

                                        <Title order={5} mb="md">
                                            Final Review
                                        </Title>

                                        <Textarea
                                            label="Review Team Remarks"
                                            placeholder="Enter final review remarks..."
                                            minRows={4}
                                            value={reviewRemarks}
                                            onChange={(e) =>
                                                setReviewRemarks(e.target.value)
                                            }
                                        />

                                        <Space h="md" />

                                        <Text fw={600}>
                                            Previous Remarks
                                        </Text>

                                        <Paper
                                            mt="xs"
                                            p="sm"
                                            bg="gray.0"
                                        >

                                            {selectedMerchant?.onboard_remark?.[0]?.reviewteam_remarks ||
                                                "No remarks added yet."}

                                        </Paper>

                                    </Paper>

                                    {/* =============================== */}
                                    {/* FINAL ACTION */}
                                    {/* =============================== */}


                                    {/* VERIFICATION ACTION */}
                                    <Paper
                                        withBorder
                                        p="lg"
                                    >

                                        <Title order={5} mb="md">
                                            Verification Action
                                        </Title>

                                        <Grid>

                                            <Grid.Col span={6}>

                                                <Select
                                                    label="Change Status"
                                                    placeholder="Select Status"
                                                    data={[
                                                        "Pending",
                                                        "Under Review",
                                                        "Approved",
                                                        "Rejected",
                                                        "Rectification Required",
                                                    ]}
                                                    value={status}
                                                    onChange={setStatus}
                                                />

                                            </Grid.Col>

                                            <Grid.Col span={6}>

                                                <NumberInput
                                                    label="Verification Step"
                                                    min={1}
                                                    max={5}
                                                    value={verificationStep}
                                                    onChange={setVerificationStep}
                                                />

                                            </Grid.Col>

                                        </Grid>
                                        {/* RECTIFICATION  */}
                                        {
                                            status === "Rectification Required" && (
                                                <>
                                                    <Paper
                                                        withBorder
                                                        p="lg"
                                                        mt={'xs'}
                                                    >

                                                        <Title
                                                            order={5}
                                                            mb="lg"
                                                        >
                                                            Rectification Required
                                                        </Title>

                                                        <Text
                                                            c="dimmed"
                                                            mb="lg"
                                                        >
                                                            Select the onboarding sections that require correction by the merchant.
                                                        </Text>

                                                        <Stack>

                                                            {

                                                                rectificationOptions.map(step => {

                                                                    const selected = rectificationSteps.find(
                                                                        item => item.step === step.value
                                                                    );

                                                                    return (

                                                                        <Paper
                                                                            key={step.value}
                                                                            withBorder
                                                                            p="md"
                                                                        >

                                                                            <Checkbox

                                                                                label={step.label}

                                                                                checked={!!selected}

                                                                                onChange={(event) =>

                                                                                    handleRectificationChange(
                                                                                        step,
                                                                                        event.currentTarget.checked
                                                                                    )

                                                                                }

                                                                            />

                                                                            {

                                                                                selected && (

                                                                                    <Textarea

                                                                                        mt="md"

                                                                                        label="Rectification Remark"

                                                                                        placeholder={`Enter correction required for ${step.label}`}

                                                                                        value={selected.remark}

                                                                                        onChange={(e) =>

                                                                                            handleRectificationRemark(
                                                                                                step.value,
                                                                                                e.target.value
                                                                                            )

                                                                                        }

                                                                                        minRows={3}

                                                                                    />

                                                                                )

                                                                            }

                                                                        </Paper>

                                                                    );

                                                                })

                                                            }

                                                        </Stack>

                                                    </Paper>
                                                </>
                                            )
                                        }


                                        <Group
                                            justify="flex-end"
                                            mt="xl"
                                        >

                                            <Button
                                                variant="default"
                                            >
                                                Cancel
                                            </Button>

                                            <Button
                                                color="blue"
                                                onClick={handleUpdateRemarks}
                                                loading={verificationUpdateloading}
                                            >
                                                Save Verification
                                            </Button>

                                        </Group>

                                    </Paper>

                                </Stack>

                            </Tabs.Panel>
                        </Tabs>

                        {/* =============================== */}
                        {/* REMARKS */}
                        {/* =============================== */}

                        <Paper
                            withBorder
                            p="md"
                        >

                            <Title
                                order={5}
                                mb="md"
                            >
                                Verification Remarks
                            </Title>

                            <Accordion>

                                <Accordion.Item value="ao">

                                    <Accordion.Control>

                                        AO Verification

                                    </Accordion.Control>

                                    <Accordion.Panel>

                                        {selectedMerchant
                                            ?.onboard_remark?.[0]
                                            ?.ao_remarks || "-"}

                                    </Accordion.Panel>

                                </Accordion.Item>

                                <Accordion.Item value="onboard">

                                    <Accordion.Control>

                                        Onboarding Team

                                    </Accordion.Control>

                                    <Accordion.Panel>

                                        {selectedMerchant
                                            ?.onboard_remark?.[0]
                                            ?.onboardteam_remarks || "-"}

                                    </Accordion.Panel>

                                </Accordion.Item>

                                <Accordion.Item value="legal">

                                    <Accordion.Control>

                                        Legal Team

                                    </Accordion.Control>

                                    <Accordion.Panel>

                                        {selectedMerchant
                                            ?.onboard_remark?.[0]
                                            ?.leagalteam_remarks || "-"}

                                    </Accordion.Panel>

                                </Accordion.Item>

                                <Accordion.Item value="review">

                                    <Accordion.Control>

                                        Review Team

                                    </Accordion.Control>

                                    <Accordion.Panel>

                                        {selectedMerchant
                                            ?.onboard_remark?.[0]
                                            ?.reviewteam_remarks || "-"}

                                    </Accordion.Panel>

                                </Accordion.Item>

                            </Accordion>

                        </Paper>

                    </Stack>

                )}

            </Drawer>

        </Box>
    );
};

export default MerchantOnboard;